module.exports = __webpack_public_path__ + "img/36_69.4d779001.png";